document.addEventListener("DOMContentLoaded", function () {
  const referrer = document.referrer;
  var link = document.getElementById('dynamicLink');
  const brand = document.querySelectorAll('.style_vendor')[0];
  const brandLink = document.querySelectorAll('#brandLink')[0];
  const categoryBred = document.querySelectorAll('.categoryBreadcrumb')[0];
  const dynamicBred = document.querySelectorAll('.dynamicBreadcrumb')[0];
  const sequraWidget = document.getElementsByClassName('sequra-promotion-widget')[0];

  if (referrer && !referrer.includes("google") && !referrer.includes("/products/") && !referrer.includes("perfumes-multimarca")) {
    var baseUrl = referrer.split('?')[0];
    var lastPart = baseUrl.split('/').pop().replace(/[^a-zA-Z0-9]/g, ' ');
    var cleanLastPart = lastPart.replace(/\b\w/g, char => char.toUpperCase());
    var wordsToRemove = ["Home", "Dona", "Hombre", "Mujer", "Man", "Woman", "Mann", "Frau", "Homme", "Fem", "Uomo", "Donna"];

    wordsToRemove.forEach(word => {
      cleanLastPart = cleanLastPart.replace(new RegExp("\\b" + word + "\\b", "gi"), "");
    });

    cleanLastPart = cleanLastPart.trim().replace(/\s+/g, ' ');

    if (link !== null) {
      link.setAttribute('href', baseUrl);
      link.setAttribute('title', cleanLastPart);
      link.textContent = cleanLastPart;
    }
    if(dynamicBred){
      dynamicBred.style.display = "inline"; // Show the link
    }
  } else if (referrer.includes("/products/")) { //If came from another product
    if (typeof brandLink !== 'undefined' && typeof categoryBred !== 'undefined') {
      brandLink.setAttribute('href', brand.href);
      categoryBred.style.display = "inline";
    }
    if(dynamicBred){
      dynamicBred.style.display = "none";
    }
  } else if (referrer.includes("google")) { // If came from google
    // Hide the link and prefix if there is no referrer or if it's from Google
    if (typeof link !== 'undefined' && typeof brandLink !== 'undefined' && typeof categoryBred !== 'undefined') {
      link.style.display = "none";
      brandLink.setAttribute('href', brand.href);
      categoryBred.style.display = "inline";
    }
    
    document.querySelectorAll('.brandBreadcrumb')[0].style.display = "inline";
  } else if (referrer.includes("perfumes-multimarca")) { // If came from perfumes
    if (typeof link !== 'undefined' && typeof brandLink !== 'undefined' && typeof categoryBred !== 'undefined') {
      link.style.display = "none";
      brandLink.setAttribute('href', brand.href);
      categoryBred.style.display = "none";
    }
    document.querySelectorAll('.brandBreadcrumb')[0].style.display = "inline";
  }

  /* Custom our 'Avísame' popup */
  const checkIfLoaded = () => {
    const container = document.querySelector('.modal90-left');
    const successpg = document.querySelector('.modal90-success');

    if (document.getElementById('semgetpouplink') && container && successpg) {
      const customParagraph = document.querySelector('.modal90-conditions')?.textContent;

      if (customParagraph) {
        const paragraphElement = document.createElement('p');
        paragraphElement.className = 'modal90-conditions';
        paragraphElement.textContent = customParagraph;
        container.appendChild(paragraphElement);
      }

      const successtext = successpg.textContent;
      const paragraphSuccess = document.createElement('p');
      paragraphSuccess.textContent = successtext;

      successpg.textContent = "";
      successpg.append(paragraphSuccess);
      container.parentElement?.appendChild(successpg);

      document.querySelectorAll('.input-label').forEach(input => input.style.display = 'none');

      document.getElementById('custsemgetembedbtn')?.addEventListener('click', () => {
        container.style.display = "none";
        successpg.style.display = "block";
      });
    } else {
      setTimeout(checkIfLoaded, 100);
    }
  };

  checkIfLoaded();
  /* End */

  const hideSequra = () => sequraWidget && (sequraWidget.style.display = "none");
  //Hide sequra div if variant option doesn't have stock, and display if has stock
  var elements = document.getElementsByClassName('product-form__input--block');
  if (elements.length > 0) {
    var childInputs = document.getElementsByClassName('product-form__input--block')[0].querySelectorAll('input');
    // Add event listener to each input
    childInputs.forEach(function (input) {
      input.addEventListener('click', function () {
        if (input.classList.contains('is-disabled')) {
          setTimeout(hideSequra, 100);
        } else {
          if(sequraWidget){
            sequraWidget.style.display = "block";
          }
        }
      });
    });
  } else {
    setTimeout(hideSequra, 100);
  }
  /* End */

  /*Klarna*/
  function addCustomStyles() {
    const klarnaPlacement = document.querySelector('klarna-placement[data-key="credit-promotion-badge"]');

    if (klarnaPlacement && klarnaPlacement.shadowRoot) {
      const shadowRoot = klarnaPlacement.shadowRoot;
      const style = document.createElement('style');
      style.type = 'text/css';
      style.innerHTML = `
                .credit-promotion-badge .container{
                    font-family: "Mier A", sans-serif;
                    border: 0px !important;
                    align-items: flex-start;
                    padding: 5px 0px 0px;
                    flex-direction: row-reverse !important;
                }
                .credit-promotion-badge .container .link{
                    font-family: "Mier A", sans-serif;
                }
            `;
      shadowRoot.appendChild(style);
    }
  }

  setTimeout(addCustomStyles, 500);
  /*End Klarna*/

  /*Hide Cares in product page for products without this value (books, glasses...)*/
  var accordionContents = document.querySelectorAll('.product__accordion .accordion__content');
  var middleElement;

  if (accordionContents.length % 2 !== 0) {
    middleElement = accordionContents[Math.floor(accordionContents.length / 2)];
    if (middleElement.textContent.trim() === '') {
      //Ocultamos el div
      middleElement.parentElement.parentElement.style.display = "none";
    } else {
      //Hay contenido, lo mostramos
    }
  } else {
    //No hay un elemento del medio porque el número de elementos es par
    //console.log('No hay un elemento del medio porque el número de elementos es par');
  }
  /* End hide */
  
/* Start Scroll and filter div validations */
  var scrollFilterFunc = function () {
    var element = document.querySelector('facet-filters-form.facets--bar');
    if(element){
      var position = element.getBoundingClientRect();
      // Si el scroll tapa el div
      if (window.scrollY >= position.bottom) {
        if (!element.classList.contains("sticky")) {
          element.classList.add("sticky");
        }
      } else if(window.scrollY <= position.bottom) {
        if (element.classList.contains("sticky")) {
          element.classList.remove("sticky");
        }
      }
    }

    var element = document.querySelector('.production-information-sticky .variantsdiv');
    if(element){
      if (window.scrollY > 200) {
        $(".free-shipping-sticky .shipping-info, .sequra-promotion-widget").show();
      } else {
        $(".free-shipping-sticky .shipping-info, .sequra-promotion-widget").hide();
        
        /*if($(".variations .product-form__input--block input[type=radio]+label").length <2){
          $(".variantsdiv, .buy-options").show();
          $(".displaySizes").hide();
        }else */
        if($('#showSizes').is(":hidden")){
         if($(".buy-options").hasClass("novendible") != true){
            $(".variantsdiv, .buy-options").hide();
            $(".displaySizes").show();
          } 
        }
      }
    }


    var element = $('.menu-novios');
    if(element){
      if (window.scrollY > 70) {
        $(".menu-novios-sticky .breadcrumbs").hide();
      }else{
        $(".menu-novios-sticky .breadcrumbs").show();
      }
    }
  };

  window.addEventListener("scroll", scrollFilterFunc);

  /* Start hover menu and hide or show filters */
  document.addEventListener('mouseover', function(event) {
    if (event.target.closest('.thb-full-menu li.menu-item-has-children.menu-item-has-megamenu')) {
      const facetsBarSticky = document.querySelector('.facets--bar.sticky');
      if (facetsBarSticky) {
          facetsBarSticky.classList.add('underMenu');
      }
    }
  });

  document.addEventListener('mouseout', function(event) {
    if (event.target.closest('.thb-full-menu li.menu-item-has-children.menu-item-has-megamenu')) {
      const facetsBarSticky = document.querySelector('.facets--bar.sticky');
      if (facetsBarSticky) {
          facetsBarSticky.classList.remove('underMenu');
      }
    }
  });
  /* End hover menu and hide or show filters */
  /* End Scroll and filter div validations */

  function isMobile() {
        return window.matchMedia("only screen and (max-width: 767px)").matches;
  }

  if (isMobile()) {    
    const $productionInfoSticky = $('.production-information-sticky');
    $(".product-information-desktop .sequra-promotion-widget").remove();
    $(".thb-product-detail h1.product-title, .product-title-container, .variantsdiv, .buy-options, .displaySizes, .free-shipping-sticky, .sequra-promotion-widget").detach().appendTo($productionInfoSticky);
    if($(".buy-options").hasClass("novendible") != true){
      $(".buy-options").hide();
    }
    $(".variantsdiv, .sequra-promotion-widget, .free-shipping-sticky .shipping-info").hide();
    $(".displaySizes, .free-shipping-sticky, .color-size-options").show();
    $(".shopify-section.breadcrumbs-section").insertBefore($('.product-information-desktop .product-information--inner.collapsible-row').first());

  if($(".variations .product-form__input--block input[type=radio]+label").length <2){
      //$(".variantsdiv, .buy-options").show();
      //$(".displaySizes").hide();
    }
    
  } else {
    const $sequraWidgets = $(".sequra-promotion-widget");
    if ($sequraWidgets.length > 1) {
      $sequraWidgets.eq(1).remove();
    }
  }
  
    const showSizesButton = document.getElementById('showSizes');
    showSizesButton?.addEventListener('click', function() {
      $(".displaySizes").hide();
      $(".variantsdiv, .buy-options").show();
    });

  if($("#ReserveText").is(":visible")){
    $(".ficha-servicios, .sequra-promotion-widget, klarna-placement").hide();
  }

  if($(".cart-drawer .free-shipping").is(":visible") && !$("#main-cart-free-shipping .free-shipping").length){
    $(".side-panel-content .free-shipping").clone().appendTo('#main-cart-free-shipping');
  }

  // Lista de días festivos (formato DD-MM, sin año)
  const lang = Shopify.locale;
  const diasFestivos = new Set(["01-01","06-01","18-04","21-04","01-05","09-06","24-06","15-08","11-09","24-09","01-11","12-10","06-12","08-12","25-12","26-12"]);
  const nombresMesesPorIdioma = {
    'es': ["Ene", "Feb", "Mar", "Abr", "May", "Jun", "Jul", "Ago", "Sep", "Oct", "Nov", "Dic"],
    'en': ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"],
    'it': ["Gen", "Feb", "Mar", "Apr", "Mag", "Giu", "Lug", "Ago", "Set", "Ott", "Nov", "Dic"],
    'fr': ["Janv", "Févr", "Mars", "Avr", "Mai", "Juin", "Juil", "Août", "Sept", "Oct", "Nov", "Déc"],
    'ca': ["Gen", "Febr", "Març", "Abr", "Mai", "Juny", "Jul", "Ag", "Set", "Oct", "Nov", "Des"],
    'de': ["Jan", "Feb", "Mär", "Apr", "Mai", "Jun", "Jul", "Aug", "Sep", "Okt", "Nov", "Dez"]
  };

  // Función para comprobar si una fecha es festivo
  function esFestivo(fecha) {
    const diaMes = ('0' + fecha.getDate()).slice(-2) + '-' + ('0' + (fecha.getMonth() + 1)).slice(-2); // Formato DD-MM
    return diasFestivos.has(diaMes);
  }

  // Función para formatear la fecha en DD-MM-YYYY
  function formatearFecha(fecha) {
    const dia = fecha.getDate();
    const nombresMeses = nombresMesesPorIdioma[lang] || nombresMesesPorIdioma['en'];
    const mes = nombresMeses[fecha.getMonth()];
    
    return `${dia} ${mes}`;
  }

  // Función para obtener el próximo día laborable
  function obtenerProximoDiaLaborable(dias) {
    let fecha = new Date();
    fecha.setDate(fecha.getDate() + dias);  
    let diaSemana = fecha.getDay();
    
    // Si es sábado (6) y días es 1, sumar 2 días. Si es domingo (0), sumar 1 día.
    if (diaSemana === 6) {
        fecha.setDate(fecha.getDate() + 2);
    } else if (diaSemana === 0) {
        fecha.setDate(fecha.getDate() + 1);
    }

    //Validamos que no sea un festivo de la lista
    while (esFestivo(fecha)) {
      fecha.setDate(fecha.getDate() + 1);
    }
    
    // Ahora que estamos en un día laborable, verificamos si es festivo
    if (dias > 1) {
        let diaAnterior = new Date();
        diaAnterior.setDate(diaAnterior.getDate() + (dias - 1));
        let fechaAnteriorLaborable = obtenerProximoDiaLaborable(dias - 1);

        if (formatearFecha(fecha) === fechaAnteriorLaborable) {
            fecha.setDate(fecha.getDate() + 1);

            // Ajustar nuevamente si la nueva fecha cae en fin de semana
            diaSemana = fecha.getDay();
            if (diaSemana === 6) {
                fecha.setDate(fecha.getDate() + 2);
            } else if (diaSemana === 0) {
                fecha.setDate(fecha.getDate() + 1);
            }
        }
    }

    return formatearFecha(fecha);
  }

  // Usar la función y mostrar la fecha del próximo día laborable
  const dia24h = obtenerProximoDiaLaborable(1);
  const dia48h = obtenerProximoDiaLaborable(2);
  const dia3 = obtenerProximoDiaLaborable(3);
  const dia6 = obtenerProximoDiaLaborable(6);
  
  $(".availability-estimated-dates .estimated-date").text(dia24h+" - "+dia48h);
  $(".availability-estimated-dates .estimated-int-date").text(dia3+" - "+dia6);

  //Controles botones slideshow
  const slideshow = document.querySelector('.main-slideshow');
  const flkty = Flickity.data(slideshow);
  if(slideshow){
    document.querySelector('.prev-button').addEventListener('click', function () {
        flkty.previous();
    });
    document.querySelector('.next-button').addEventListener('click', function () {
        flkty.next();
    });
  }

  //START Reserves
  const btnReserves = document.getElementById("ReserveToStore");
  if (btnReserves) {
    btnReserves.addEventListener("click", function () {
      document.getElementById('reserve_in_sotore_modal_title_default').style.display = "block";
      document.getElementById('reserve_in_sotore_modal_title_error').style.display = "none";
      document.getElementById('reserve_in_sotore_modal_title_success').style.display = "none";
    
      let size = document.querySelector('input[name="Size"]:checked').value;
      let color = document.querySelector('input[name="Color"]:checked').value;
  
      let newColor = document.querySelector('.product-form__input--color .form__label__value').textContent.replace(/(\r\n|\n|\r)/gm,"");
      
      document.getElementById('option-Size').innerHTML = size;
      document.getElementById('option-Color').innerHTML = newColor;
      
      document.getElementById('size').value = size;
      document.getElementById('color').value = color;
      
      document.getElementById('transaction_modal_default').style.display = "block";
      document.getElementById('transaction_modal_success').style.display = "none";
      document.getElementById('transaction_modal_error').style.display = "none";
    });
  
    async function postData(url = "", data = {}) {
      try {
        // Default options are marked with *
        let response = await fetch(url, {
          method: "POST", // *GET, POST, PUT, DELETE, etc.
          mode: "cors", // no-cors, *cors, same-origin
          cache: "no-cache", // *default, no-cache, reload, force-cache, only-if-cached
          credentials: "omit", // include, *same-origin, omit
          headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json;charset=utf-8',
          'Access-Control-Allow-Origin': '*'
          },
          redirect: "follow", // manual, *follow, error
          referrerPolicy: "no-referrer", // no-referrer, *no-referrer-when-downgrade, origin, origin-when-cross-origin, same-origin, strict-origin, strict-origin-when-cross-origin, unsafe-url
          body: JSON.stringify(data), // body data type must match "Content-Type" header
        });
        
        if(response.status == 200) {
          return await response.json();
        }
        return response;
        
      } catch (error) {
        // TypeError: Failed to fetch
        console.log('There was an error', error);
      }
     
      return response.json() // parses JSON response into native JavaScript objects
    }
    
    let form = document.getElementById('reserve-form');
    let pristine = new Pristine(form);
    form.addEventListener('submit', function (e) {
      e.preventDefault();

      var finalPriceElement = $('#PopupModal-reserve-in-store .discounts__discount .final-price');
      var reservePrice;
      if (finalPriceElement.length > 0) {
          var finalPriceWithSymbol = finalPriceElement.text();
          reservePrice = finalPriceWithSymbol.replace(/[^\d]/g, '');
      } else {
          var amountWithSymbol = $('#PopupModal-reserve-in-store .discounts__discount .amount').first().text();
          reservePrice = amountWithSymbol.replace(/[^\d]/g, '');
      }
      reservePrice = Number(reservePrice) * 100;

      var reserveImage = $('#PopupModal-reserve-in-store .product-cart-item-image img').attr('src');
      reserveImage = reserveImage.replace("//www.santaeulalia.com/cdn/shop/","");
      
      let valid = pristine.validate();
      if(valid){
        let data = {
          locale: Shopify.locale,
          sku: form[0].value,
          size: form[1].value,
          color: form[2].value,
          name: form[3].value,
          lastname: form[4].value,
          email: form[5].value,
          phone: form[6].value,
          image: reserveImage,
          title: $('#PopupModal-reserve-in-store .cart-product-link').text(),
          price: reservePrice,
          brand: $('#PopupModal-reserve-in-store .product-card-vendor a').text()
        };

        postData("https://www.santaeulalia.com/apps/ereserve", data).then((result) => {
          if(result.status == 'ok') {
            let reserveNumber = ('000000000'+result.data.id).slice(-9);
            document.getElementById('reserve-number').innerHTML = reserveNumber;
            
            document.getElementById('reserve_in_sotore_modal_title_default').style.display = "none";
            document.getElementById('reserve_in_sotore_modal_title_success').style.display = "block";
            document.getElementById('reserve_in_sotore_modal_title_error').style.display = "none";
            
            document.getElementById('transaction_modal_default').style.display = "none";
            document.getElementById('transaction_modal_success').style.display = "block";
            document.getElementById('transaction_modal_error').style.display = "none";
          } else {
            document.getElementById('reserve_in_sotore_modal_title_default').style.display = "none";
            document.getElementById('reserve_in_sotore_modal_title_success').style.display = "none";
            document.getElementById('reserve_in_sotore_modal_title_error').style.display = "block";
      
            document.getElementById('transaction_modal_default').style.display = "none";
            document.getElementById('transaction_modal_success').style.display = "none";
            document.getElementById('transaction_modal_error').style.display = "block";
          }
          document.getElementById("reserve-form").reset();
          //console.log(result.status); // JSON data parsed by `data.json()` call
        });
      }
    });
  }
  //End Reserves

  var element = $('.menu-novios');
  if (element.length) {
      element.closest('.shopify-section.spaced-section').addClass('menu-novios-sticky');
  }
  //shopify-section spaced-section

  var formNovios = $('#form-groom');
  if (formNovios.length) {
    //Section form for appointments
    let closedDays = $("#groom-info-hidde #not_available_groom").val();
    let langform = document.getElementById("lang").dataset.language;
    let form = document.getElementById("form-groom");
    let pristine = new Pristine(form);
    
    // Define horarios normales y de sábados
    let normalMinTime = $("#groom-info-hidde #open_groom").val();
    let normalMaxTime = $("#groom-info-hidde #close_groom").val();
    let saturdayMinTime = $("#groom-info-hidde #open_groom_saturday").val();
    let saturdayMaxTime = $("#groom-info-hidde #close_groom_saturday").val();
    
    flatpickr("#appointment-date", {
      "locale": langform,
      enableTime: true,
      dateFormat: "Y-m-d H:i",
      altInput: true,
      timeFormat: "h:i K",
      altFormat: "F j, Y. h:i K",
      minDate: new Date().fp_incr(1),
      maxDate: new Date().fp_incr(365),
      minuteIncrement: 15,
      "disable": [
        function(date) {
          let day = date.getDate();
          let month = date.getMonth() + 1;
          let year = date.getFullYear();
          if (day < 10) {
            day = '0' + day;
          }
          if (month < 10) {
            month = `0${month}`;
          }
          let formatted = year + "-" + month + "-" + day;
          // return true to disable
          return (date.getDay() === 0 || closedDays.split(",").includes(formatted));
        }
      ],
      minTime: normalMinTime,
      maxTime: normalMaxTime,
      onChange: function(selectedDates, dateStr, instance) {
      
        // Verificar si el día seleccionado es sábado
        let selectedDate = new Date(selectedDates[0]);
        
        if (selectedDate.getDay() === 6) { // Sábado
          instance.set("minTime", saturdayMinTime);
          instance.set("maxTime", saturdayMaxTime);
        } else {
          instance.set("minTime", normalMinTime);
          instance.set("maxTime", normalMaxTime);
        }
      }
    });
    
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      let valid = pristine.validate();
      if(valid){
        let data = {
          locale: Shopify.locale,
          name: form[0].value,
          lastname: form[1].value,
          email: form[2].value,
          phone: form[3].value,
          date: form[4].value,
          hearaboutus: form[6].value,
          comments: form[7].value,
        };
        postData($("#groom-info-hidde #general_url").val()+"/groom", data).then((result) => {
          if(result.status == 'ok') {
            window.location.replace($("#groom-info-hidde #groom_success").val())
          } else {
            window.location.replace($("#groom-info-hidde #groom_error").val())
          }
          console.log(result.status); // JSON data parsed by `data.json()` call
        });
        pristine.reset();
        document.getElementById("form-groom").reset();
      };
    });
    //End form appointment
  }

  var formInvitadas = $('#form-invitadas');
  if (formInvitadas.length) {
    //Section form for appointments
    let closedDays = $("#invitadas-info-hidde #not_available_invitadas").val();
    let langform = document.getElementById("lang").dataset.language;
    let form = document.getElementById("form-invitadas");
    let pristine = new Pristine(form);
    
    // Define horarios normales y de sábados
    let normalMinTime = $("#invitadas-info-hidde #open_invitadas").val();
    let normalMaxTime = $("#invitadas-info-hidde #close_invitadas").val();
    let saturdayMinTime = $("#invitadas-info-hidde #open_invitadas_saturday").val();
    let saturdayMaxTime = $("#invitadas-info-hidde #close_invitadas_saturday").val();
    
    flatpickr("#appointment-date", {
      "locale": langform,
      enableTime: true,
      dateFormat: "Y-m-d H:i",
      altInput: true,
      timeFormat: "h:i K",
      altFormat: "F j, Y. h:i K",
      minDate: new Date().fp_incr(1),
      maxDate: new Date().fp_incr(365),
      minuteIncrement: 15,
      "disable": [
        function(date) {
          let day = date.getDate();
          let month = date.getMonth() + 1;
          let year = date.getFullYear();
          if (day < 10) {
            day = '0' + day;
          }
          if (month < 10) {
            month = `0${month}`;
          }
          let formatted = year + "-" + month + "-" + day;
          // return true to disable
          return (date.getDay() === 0 || closedDays.split(",").includes(formatted));
        }
      ],
      minTime: normalMinTime,
      maxTime: normalMaxTime,
      onChange: function(selectedDates, dateStr, instance) {
      
        // Verificar si el día seleccionado es sábado
        let selectedDate = new Date(selectedDates[0]);
        
        if (selectedDate.getDay() === 6) { // Sábado
          instance.set("minTime", saturdayMinTime);
          instance.set("maxTime", saturdayMaxTime);
        } else {
          instance.set("minTime", normalMinTime);
          instance.set("maxTime", normalMaxTime);
        }
      }
    });
    
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      let valid = pristine.validate();
      if(valid){
        let data = {
          locale: Shopify.locale,
          name: form[0].value,
          lastname: form[1].value,
          email: form[2].value,
          phone: form[3].value,
          date: form[4].value,
          hearaboutus: form[6].value,
          comments: form[7].value,
        };
        postData($("#invitadas-info-hidde #general_url").val()+"/guest-dresses", data).then((result) => {
          if(result.status == 'ok') {
            window.location.replace($("#invitadas-info-hidde #invitadas_success").val())
          } else {
            window.location.replace($("#invitadas-info-hidde #invitadas_error").val())
          }
          console.log(result.status); // JSON data parsed by `data.json()` call
        });
        pristine.reset();
        document.getElementById("form-invitadas").reset();
      };
    });
    //End form appointment
  }

  var formSastreria = $('#form-tailoring');
  if (formSastreria.length) {
    let closedDays = $("#tailoring-info-hidde #not_available_tailoring").val();
    let langform = document.getElementById("lang").dataset.language;
    let form = document.getElementById("form-tailoring");
    let pristine = new Pristine(form);
    
    // Define horarios normales y de sábados
    let normalMinTime = $("#tailoring-info-hidde #open_tailoring").val();
    let normalMaxTime = $("#tailoring-info-hidde #close_tailoring").val();
    let saturdayMinTime = $("#tailoring-info-hidde #open_tailoring_saturday").val();
    let saturdayMaxTime = $("#tailoring-info-hidde #close_tailoring_saturday").val();
    flatpickr("#appointment-date", {
      "locale": lang,
      enableTime: true,
      dateFormat: "Y-m-d H:i",
      altInput: true,
      timeFormat: "h:i K",
      altFormat: "F j, Y. h:i K",
      minDate: new Date().fp_incr(1),
      maxDate: new Date().fp_incr(365),
      minuteIncrement: 15,
      "disable": [
          function(date) {
            let day = date.getDate();
            let month = date.getMonth()+1;
            let year = date.getFullYear();
            if (day < 10) {
              day = '0' + day;
            }
            if (month < 10) {
              month = `0${month}`;
            }
            let formated = year + "-" + month + "-" + day;
              // return true to disable
              return (date.getDay() === 0 || date.getDay() === 6 || closedDays.split(",").includes(formated))
          }
      ],
      minTime: normalMinTime,
      maxTime: normalMaxTime,
    });
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      let valid = pristine.validate();
      if(valid){
        let data = {
          locale: Shopify.locale,
          name: form[0].value,
          lastname: form[1].value,
          email: form[2].value,
          phone: form[3].value,
          date: form[4].value,
          comments: form[6].value,
        };    
        postData($("#tailoring-info-hidde #general_url").val()+"/tailoring", data).then((result) => {
          if(result.status == 'ok') {
            window.location.replace($("#tailoring-info-hidde #tailoring_success").val())
          } else {
            window.location.replace($("#tailoring-info-hidde #tailoring_error").val())
          }
          console.log(result.status); // JSON data parsed by `data.json()` call
        });
        pristine.reset();
        document.getElementById("form-tailoring").reset();
      };
    });
  }

  var formBistrot = $('#form-bistrot');
  if (formBistrot.length) {
    let closedDays = $("#bistrot-info-hidde #not_available_bistrot").val();
    let langform = document.getElementById("lang").dataset.language;
    let form = document.getElementById("form-bistrot");
    let pristine = new Pristine(form);
    
    // Define horarios normales y de sábados
    let normalMinTime = $("#bistrot-info-hidde #open_bistrot").val();
    let normalMaxTime = $("#bistrot-info-hidde #close_bistrot").val();
    let saturdayMinTime = $("#bistrot-info-hidde #open_bistrot_saturday").val();
    let saturdayMaxTime = $("#bistrot-info-hidde #close_bistrot_saturday").val();
    
    flatpickr("#appointment-date", {
      "locale": lang,
      enableTime: true,
      dateFormat: "Y-m-d H:i",
      altInput: true,
      timeFormat: "h:i K",
      altFormat: "F j, Y. h:i K",
      minDate: new Date().fp_incr(1),
      maxDate: new Date().fp_incr(365),
      minuteIncrement: 15,
      "disable": [
          function(date) {
            let day = date.getDate();
            let month = date.getMonth()+1;
            let year = date.getFullYear();
            if (day < 10) {
              day = '0' + day;
            }
            if (month < 10) {
              month = `0${month}`;
            }
            let formated = year + "-" + month + "-" + day;
              // return true to disable
              return (date.getDay() === 0 || closedDays.split(",").includes(formated))
          }
      ],
      minTime: normalMinTime,
      maxTime: normalMaxTime,
    });
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      let valid = pristine.validate();
      if(valid){
        let data = {
          locale: Shopify.locale,
          name: form[0].value,
          lastname: form[1].value,
          email: form[2].value,
          phone: form[3].value,
          people: form[4].value,
          date: form[5].value,
          comments: form[7].value,
        };
        postData($("#bistrot-info-hidde #general_url").val()+"/bistrot", data).then((result) => {
          if(result.status == 'ok') {
            window.location.replace($("#bistrot-info-hidde #bistrot_success").val())
          } else {
            window.location.replace($("#bistrot-info-hidde #bistrot_error").val())
          }
          console.log(result.status); // JSON data parsed by `data.json()` call
        });
        pristine.reset()
        document.getElementById("form-bistrot").reset();
      };
    });
  }

  var formAppointment = $('#form-appointment');
  if (formAppointment.length) {
    let closedDays = $("#appointment-info-hidde #not_available_appointment").val();
    let langform = document.getElementById("lang").dataset.language;
    let form = document.getElementById("form-appointment");
    let pristine = new Pristine(form);
    
    // Define horarios normales y de sábados
    let normalMinTime = $("#appointment-info-hidde #open_appointment").val();
    let normalMaxTime = $("#appointment-info-hidde #close_appointment").val();
    let saturdayMinTime = $("#appointment-info-hidde #open_appointment_saturday").val();
    let saturdayMaxTime = $("#appointment-info-hidde #close_bistrot_saturday").val();
    
    flatpickr("#appointment-date", {
      "locale": lang,
      enableTime: true,
      dateFormat: "Y-m-d H:i",
      altInput: true,
      timeFormat: "h:i K",
      altFormat: "F j, Y. h:i K",
      minDate: new Date().fp_incr(1),
      maxDate: new Date().fp_incr(365),
      minuteIncrement: 15,
      "disable": [
          function(date) {
            let day = date.getDate();
            let month = date.getMonth()+1;
            let year = date.getFullYear();
            if (day < 10) {
              day = '0' + day;
            }
            if (month < 10) {
              month = `0${month}`;
            }
            let formated = year + "-" + month + "-" + day;
              // return true to disable
              return (date.getDay() === 0 || closedDays.split(",").includes(formated))
          }
      ],
      minTime: normalMinTime,
      maxTime: normalMaxTime,
    });
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      let valid = pristine.validate();
      if(valid){
        let data = {
          locale: Shopify.locale,
          name: form[0].value,
          lastname: form[1].value,
          email: form[2].value,
          phone: form[3].value,
          section: form[4].value,
          type: form[5].value,
          language: form[6].value,
          date: form[7].value,
          comments: form[9].value,
        };
        postData("https://www.santaeulalia.com/apps/ereserve"+"/store", data).then((result) => {
          if(result.status == 'ok') {
            window.location.replace($("#appointment-info-hidde #appointment_success").val())
          } else {
            window.location.replace($("#appointment-info-hidde #appointment_error").val())
          }
          console.log(result.status); // JSON data parsed by `data.json()` call
        });
        pristine.reset();
        document.getElementById("form-appointment").reset();
      }else {
        let element = document.getElementById("error-is_terms");
        if(element !== null) {
          element.remove();
        }
  
        let checkBox = document.getElementById("is_terms");
        if (checkBox.checked == false){
          node = document.querySelectorAll('.checkbox-label[for="is_terms"]');
  
          let html_error = '<div class="pristine-error text-help" id="error-is_terms" role="alert">'+checkBox.dataset.pristineRequiredMessage+'</div>';
          node[0].insertAdjacentHTML('afterend', html_error);
        }
      };
    });
  }

  async function postData(url = "", data = {}) {
      try {
        // Default options are marked with *
        let response = await fetch(url, {
          method: "POST", // *GET, POST, PUT, DELETE, etc.
          mode: "cors", // no-cors, *cors, same-origin
          cache: "no-cache", // *default, no-cache, reload, force-cache, only-if-cached
          credentials: "omit", // include, *same-origin, omit
          headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json;charset=utf-8',
          'Access-Control-Allow-Origin': '*'
          },
          redirect: "follow", // manual, *follow, error
          referrerPolicy: "no-referrer", // no-referrer, *no-referrer-when-downgrade, origin, origin-when-cross-origin, same-origin, strict-origin, strict-origin-when-cross-origin, unsafe-url
          body: JSON.stringify(data), // body data type must match "Content-Type" header
        });
        if(response.status == 200) {
          return await response.json();
        }
        return response;
      } catch (error) {
        // TypeError: Failed to fetch
        console.log('There was an error', error);
      }
      return response.json() // parses JSON response into native JavaScript objects
    }
  

  const comodidadPago = document.getElementsByClassName('comodidad-pago-popup')[0];
  if (comodidadPago) {
    comodidadPago.addEventListener('click', function () {
      document.getElementById('ProductPopup-noviosCondiciones').click();
    });
  }

  var columnBtns = document.getElementsByClassName('column-btn-ver-mas');
  if(columnBtns){
    for (var i = 0; i < columnBtns.length; i++) {
      columnBtns[i].addEventListener('click', function () {
        var parent = this.parentElement || this.parentNode;
        var content = parent.querySelector('.column-ver-mas');
        if (content) {
          content.classList.add('column-full');
        }
        this.style.display = 'none';
      });
    }
  }

  //Controlamos el click para reactivar el hover en el menú para la sección de novios
  const fullMenu = document.querySelector('.header>.row>.columns');
  if (fullMenu) {
    fullMenu.addEventListener('click', function () {
      if (document.querySelector("body").classList.contains('no-hover-menu')) {
        document.querySelector("body").classList.remove('no-hover-menu');
      }
    });
  }
  //Fin

  flatpickr("#birthdate", {
      "locale": lang,
      enableTime: false,
      dateFormat: "Y-m-d",
      altInput: true,
      timeFormat: "h:i K",
      altFormat: "F j, Y",
      //minDate: new Date().fp_incr(1),
      //maxDate: new Date().fp_incr(0),
    });
  
  //Fin novios

  //Contador productos en la landing new-collection
  $('.counterProducts h3').each(function() {
    var $this = $(this),
        countTo = parseInt($this.attr('data-count'));

    $({ countNum: 0 }).animate(
      { countNum: countTo },
      {
        duration: 2000, // duración en milisegundos
        easing: 'swing', // efecto de transición
        step: function() {
          $this.text(Math.floor(this.countNum));
        },
        complete: function() {
          $this.text(this.countNum);
        }
      }
    );
  });
  //Fin contador

  /*Texto de los banners / cabeceras */
  const descriptionContainer = document.querySelector('.collection-banner--description');
  if (descriptionContainer) {
    const paragraphs = descriptionContainer.querySelectorAll('p');
    let pdesc = null;

    // Buscar el primer párrafo con contenido real
    for (let p of paragraphs) {
      if (p.textContent.trim().length > 0) {
        pdesc = p;
        break;
      }
    }

    if (pdesc) {
      const isTruncated = pdesc.scrollHeight > pdesc.clientHeight;
      const seeMoreLink = descriptionContainer.querySelector('.see-more');
      if (seeMoreLink) {
        seeMoreLink.style.display = isTruncated ? "block" : "none";
        seeMoreLink.addEventListener('click', function (event) {
          event.preventDefault();
          descriptionContainer.classList.toggle('show-full');
          this.textContent = descriptionContainer.classList.contains('show-full') ? 'Ver menos' : 'Ver más';
        });
      }
    }
  }
  /* FIN texto banners */
  
});